import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

  @Component({
  selector: 'success_dialog',
  standalone: true,
  templateUrl: './success_dialog.component.html',
  styleUrls: ['./success_dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule
  ]
})
export class SuccessDialogComponent {
  title: string;
  content: string;
  buttons: any[];

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _dialogRef: MatDialogRef<SuccessDialogComponent>,
  ) {
    this.title = data.title;
    this.content = data.content;
    this.buttons = this.mapButtons(data.buttons);
    this._dialogRef.addPanelClass('success-dialog-panel');
  }

  /**
   * On init
   */
  ngOnInit(): void {}

  mapButtons(buttonsConfig: any[]) {
    return buttonsConfig.map(button => {
      return {
        label: button.label,
        action: this.getAction(button.action),
        class: this.getButtonClass(button.action)
      };
    });
  }

  getAction(action: string) {
    const actions: any = {
      'ok': this.close.bind(this)
    };

    return actions[action];
  }

  getButtonClass(action: string) {
    const buttonClass: any = {
      'ok': 'btn-confirm'
    };

    return buttonClass[action];
  }

  close(): void {
    this._dialogRef.close();
  }
}
